import { and, eq } from "drizzle-orm";
import { db } from "../db/index";
import { moduleSettings } from "../db/schema/rbac";

/** Core modules are always on (no row needed). Optional modules gate on module_settings. */
const CORE_MODULES = new Set(["employees", "projects", "tasks", "attendance", "leaves", "dashboard"]);

/**
 * Module-enablement gate (reskin-docs/02 §5). Legacy guards with
 * `abort_403(!in_array(MODULE, $user->modules))`. Here: a module is ON unless an explicit
 * `deactive` row exists for (company, module, type). Core modules are always ON.
 */
export async function isModuleEnabled(
  companyId: number,
  moduleName: string,
  type: "admin" | "employee" | "client" = "admin",
): Promise<boolean> {
  if (CORE_MODULES.has(moduleName)) return true;
  const row = await db
    .select({ status: moduleSettings.status })
    .from(moduleSettings)
    .where(
      and(
        eq(moduleSettings.companyId, companyId),
        eq(moduleSettings.moduleName, moduleName),
        eq(moduleSettings.type, type),
      ),
    )
    .limit(1);
  return row.length === 0 ? true : row[0]!.status === "active";
}
